<template>
    <div class="qtrust--modal row" @click="closeModal">
        <div :class="boxClass" :style="boxStyle" @click.stop>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                
            }
        },
        props : {
            'closeAble' : {
                type : Boolean,
                default : true
            },
            'boxClass' : {
                type : String,
                default : ''
            },
            'boxStyle' : {
                type : Object,
                default : () => ({})
            }
        },
        mounted () {
            this.toggleBodyScroll(true)
        },
        deactivated () {this.toggleBodyScroll(false)},
        beforeDestroy () {this.toggleBodyScroll(false)},
        destroyed () {this.toggleBodyScroll(false)},
        methods : {
            toggleBodyScroll(disable) {
                // document.body.style.overflow = disable ? 'hidden' : '';
            },
            closeModal () {
                if (this.closeAble) this.$emit('closeModal');
            }
        }
    }
</script>

<style scoped>
    .qtrust--modal {
        position: fixed;
        inset: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.6);
        overflow: hidden;

        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        z-index: 1050;
    }
</style>